<template>
  <modal-confirm
    title="이용권 변경"
    :description="description"
    @on-click-close="$emit('click-close')"
    @on-click-submit="onClickSubmit"
  >
    <template #confirm>변경</template>
  </modal-confirm>
</template>

<script setup>
  import ModalConfirm from '@/components/ui/Modal/ModalConfirm.vue'
  import { computed } from 'vue'

  const emit = defineEmits(['click-submit', 'click-close'])
  const props = defineProps({
    voucherInfo: {
      type: Object,
      required: true,
    },
  })

  /**
   *
   * @param {string} date YYYY-MM-DD HH:mm:ss
   * @returns {string} YYYY.MM.DD
   */
  const getDateFormat = (date) => {
    if (!date) return ''
    return date.split(' ')[0].replace(/-/g, '.')
  }

  const getSelectedProduct = (productList, productId) => {
    if (!productList || !productId) return {}
    return productList?.find((product) => product.productid === productId)
  }

  const description = computed(() => {
    const { voucherInfo, requestProductInfo } = props.voucherInfo
    const {
      title,
      masterTitleDescription,
      durationStart,
      durationEnd,
      purchaseAmount,
      productCode: productId,
    } = requestProductInfo
    const {
      mobile_support_device: mobileSupportDevice,
      quality,
      concurrency_count: concurrencyCount,
      purchase_amount_info_list: purchaseAmountInfoList,
    } = voucherInfo.concurrency[0]
    const selectedProduct = getSelectedProduct(
      purchaseAmountInfoList,
      productId,
    )
    const { use_day: useDay } = selectedProduct

    const duration = `${getDateFormat(durationStart)}~${getDateFormat(durationEnd)}`
    return `${title}\n${masterTitleDescription}\n${mobileSupportDevice} · ${quality} · ${concurrencyCount}회선\n\n이용기간: ${duration}\n(쿠폰 만료 후 ${useDay})\n\n금액 : ${Number(purchaseAmount).toLocaleString()}원\n\n위 상품으로 이용권을 변경하시겠습니까?`
  })

  const onClickSubmit = () => {
    const { requestProductInfo } = props.voucherInfo
    emit('click-submit', { ...requestProductInfo })
  }
</script>

<style lang="scss" scoped></style>
